export enum AlcoholProblemEnum {
    NeverDescription = 'Never',
    Never = 1,
    WithinThePastYearDescription = 'Within the past year',
    WithinThePastYear = 2,
    OverYearPlusAgoDescription = 'Over a year + ago',
    OverYearPlusAgo = 3,
}
